// extracted by mini-css-extract-plugin
module.exports = {"container":"Projects-module--container--1Ca51","project":"Projects-module--project--utFLv"};